import {getTestProps} from '@benchling/js-test-utils';
import {Color} from '@benchling/nucleus-ui';
import {createStyles, Flex, Text} from '@mantine/core';
import React from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export enum EntityMapUnavailableReason {
  ERROR = 'ERROR',
  ARCHIVED = 'ARCHIVED',
}

export const ENTITY_MAP_UNAVAILABLE_REASON_TO_MESSAGE: {[reason in EntityMapUnavailableReason]: string} = {
  [EntityMapUnavailableReason.ERROR]:
    'There was an error loading the entity map.\nRefresh your browser to try again.',
  [EntityMapUnavailableReason.ARCHIVED]: `The entity map isn't available for archived entities. To view it, \
unarchive this entity from the "Metadata" tab.`,
};

const ENTITY_MAP_UNAVAILABLE_REASON_TO_ICON: {[reason in EntityMapUnavailableReason]: BenchlingIconName} = {
  [EntityMapUnavailableReason.ERROR]: 'error',
  [EntityMapUnavailableReason.ARCHIVED]: 'archive',
};

const useStyles = createStyles(() => ({
  icon: {
    color: Color.GRAY_500,
    height: 24,
    width: 24,
    marginBottom: 8,
  },
  text: {
    whiteSpace: 'pre-wrap',
  },
}));

// TODO(BNCH-133514): Extract this into a ui-library component. Note that this component was based off of
// NoFlowchartViewer. Extract these together.
export function EntityMapUnavailableView({
  unavailableReason,
}: {
  unavailableReason: EntityMapUnavailableReason;
}): JSX.Element {
  const {classes} = useStyles();

  return (
    <Flex
      h="100%"
      bg="gray.0"
      justify="center"
      align="center"
      direction="row"
      {...getTestProps({component: 'EntityMapUnavailableView', element: 'root'})}
    >
      <Flex w="100%" direction="column" align="center">
        <BenchlingIcon
          className={classes.icon}
          icon={ENTITY_MAP_UNAVAILABLE_REASON_TO_ICON[unavailableReason]}
        />
        <Text c="gray.5" w="min(50%, 300px)" ta="center" className={classes.text}>
          {ENTITY_MAP_UNAVAILABLE_REASON_TO_MESSAGE[unavailableReason]}
        </Text>
      </Flex>
    </Flex>
  );
}
